import clsx from "clsx";
import { motion } from "motion/react";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  IReportMenuItemTranslated,
  reportsNavigationDrawerAtom,
  usePrefixedRouting,
} from "@ryde/shared";

import { getReportCategoryIcon } from "../parts";
import { reportStartPageAnimationVariants } from "./report-start-page.animations";
import { ReportStartPageItemStyled } from "./report-start-page.styled";

export const ReportStartPageItem: FC<IReportMenuItemTranslated> = ({
  titleTranslated,
  id,
  active,
  ownerCategory,
}) => {
  const setReportNavigationDrawerOpenState = useSetRecoilState(
    reportsNavigationDrawerAtom,
  );
  const { t } = useTranslation();
  const { addPrefix } = usePrefixedRouting();
  const href = useMemo(() => {
    return `/reports/${id}`;
  }, [id]);

  const handleLinkClick = (): void => {
    if (!id) {
      return;
    }

    setReportNavigationDrawerOpenState(false);
  };

  const handleItemAreaClick = (): void => {
    if (id) {
      return;
    }

    setReportNavigationDrawerOpenState(false);
  };

  return (
    <ReportStartPageItemStyled
      as={motion.div}
      variants={reportStartPageAnimationVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      onClick={handleItemAreaClick}
    >
      {!!href && (
        <Link
          to={addPrefix(href)}
          onClick={handleLinkClick}
          className={clsx({ active })}
        >
          {ownerCategory && (
            <FramerTooltip content={t(`selectListLabel.${ownerCategory}`)}>
              <>{getReportCategoryIcon(ownerCategory)}</>
            </FramerTooltip>
          )}
          <span className="report_title">{titleTranslated}</span>
        </Link>
      )}

      <SVG_MUI.ArrowsToDottedLineSVG className="arrow_item rtl_rotate" />
    </ReportStartPageItemStyled>
  );
};
